export const connectModuleCodes = {
	multipleReprocess: 287,
	multipleSkipOnHold: 288,
	fsVersion: 484,
	messageGuid: 523,
	entityGuid: 682,
	messages: 683,
	processedDate: 687,
	dependency: 688,
	dateReceived: 785,
	messageType: 787,
	searchTip: 791,
	contentType: 792,
	logLevel: 804,
	connectionType: 805,
	dateSent: 807,
	logType: 808,
	log: 811,
	receivedLog: 821,
	sentLog: 822,
	remarks: 826,
	message: 827,
	connection: 828,
	messageKeyIndicator: 830,
	logKeyIndicator: 831,
	logSearchTip: 832,
	content: 2330,
	openMessage: 2331,
	singular: 2462,
	received: 2463,
	reprocess: 5345,
	download: 10345,
	genericError: 11155,
	copyContent: 12883,
	downloadContentMessage: 12894,
	responseContent: 12915,
	settings: {
		incomingMessageSettings: 783,
		outgoingMessageSettings: 784,
		useFromParentSuccessTip: 3560,
		useCustomSmtpSettings: 5313,
		smtpHost: 5314,
		smtpPort: 5315,
		smtpIsSslEnabled: 5316,
		smtpTimeoutInSeconds: 5317,
		smtpUserName: 5318,
		smtpPassword: 5319,
		exportMessageSettings: 5405,
		importMessageSettings: 14484,
		autoApproveAccessRequest: 11437,
		supportAccess: 13134,
		connectEmailProviderType: 14201,
		emailProviderTypeTip: 14205,
		connectIgnoreUserStatusFromFs: 14476,
		connectIgnoreUserStatusFromFsInfo: 14482,
		disablePlatform: 16116,
		disableHelloFlex: 16117,
	},
	apiUser: {
		plural: 9202,
		addUser: 9211,
		friendlyName: 9204,
		type: 9205,
		guid: 9203,
		lastChangedDateTime: 9206,
		wizardSuccessTip: 9212,
		searchTip: 12917,
		foundApiUserCount: 12984,
		createNewApiUser: 12986,
		createNewApiUserDescription: 12987,
		createTemplate: 12988,
		createTemplateDescription: 12989,
		useTemplate: 12990,
		useTemplateDescription: 12991,
		allowedIps: 12474,
		invalidIpValidationMessage: 13000,
		allowedIpsPlaceholder: 13003,
		noIpsAdded: 13176,
		ipAddressesMustNotRepeat: 13177,
		addIp: 13178,
		system: 13430,
		systemTemplateTip: 13431,
		basedOnSystemTemplateTip: 13432,
		goToSystemTemplate: 13433,
	},
	keyIndicators: {
		incomingAge: 9230,
		incomingAction: 9235,
		incomingFailed: 9234,
		incomingTotal: 9232,
		connectionType: 805,
		contentType: 792,
		customer: 786,
		showOldItems: 546,
		maxMessageHours: 9238,
		messageType: 787,
		outgoingAge: 9231,
		outgoingFailed: 9236,
		outgoingTotal: 9233,
		outgoingWaiting: 9237,
		plural: 9229,
		progress: 408,
		status: 319,
	},
	incomingMessage: {
		singular: 816,
	},
	outgoingMessage: {
		singular: 817,
	},
	helloFlexWillNotBeAvailableModalTitle: 16118,
	helloFlexWillNotBeAvailableMessage: 16119,
	platformWillBeDisabledIn: 16122,
	platformHasBeenDisabledSince: 16133,
};
